import cartObject from "@/model/cart";
import { helpers, cartManager, enumHelper } from "@/utilities";
import Vue from "vue";
import store from "@/store";
import api from "@/api";

export default {
  InitCart: () => {
    let _cart = Object.assign({}, cartObject);

    if (cartManager.getCart() == null || !Vue.$storage.has("cart")) {
      cartManager.setCart(_cart, false, false);
    }

    _cart = cartManager.getCart();
    if (_cart) store.dispatch("storeOrderTotal", _cart.orderTotal);

    return _cart;

  },
  clearCart: () => {

    let _cart = Object.assign({}, cartObject);
    cartManager.setCart(_cart, true, false);
    return _cart;
  },
  getCart: () => {
    return Vue.$storage.get("cart");
  },
  setCart: (cart, _dispatch = true, submit = true) => {
    Vue.$storage.set("cart", cart, {
      ttl: helpers.getCookieTimeExpiration(),
    });

    if (_dispatch) {
      if (cart.coupon && cart.coupon_result && submit) {
        cartManager.updateCoupon(cart).then((result) => {
          cart.coupon_result = result;
          cartManager.setOrderTotal(cart).then((result) => {
            store.dispatch("storeOrderTotal", result.orderTotal);
            Vue.$storage.set("cart", result, {
              ttl: helpers.getCookieTimeExpiration(),
            });
          });
        });
      } else {
        cartManager.setOrderTotal(cart).then((result) => {
          store.dispatch("storeOrderTotal", result.orderTotal);
          Vue.$storage.set("cart", result, {
            ttl: helpers.getCookieTimeExpiration(),
          });
        });
      }
    }
  },
  saveSelectedLocation: (locations, id = -1) => {
    let location = null;
    if (locations.length == 1 && id == -1) {
      location = locations[0];
    } else if (id > 0) {
      location = locations.find((x) => x.id === id);
    }
    store.dispatch("storeSelectedLocation", location);
    store.dispatch("fetchCategories", location.id)
  },
  generateCartObject: (cart, withComment = false) => {
    let objCart = [];
    cart.order.forEach((item) => {
      let obj = {};
      obj.id = item.id;
      obj.quantity = item.quantity;
      obj.options = [];
      if (item.hasOptions > 0) {
        let arrOptions = [];
        item.options.forEach((option) => {
          //---- when one option is selected
          if (!Array.isArray(option.selected) && option.selected != "") {
            arrOptions.push({
              id: option.id,
              value: option.selected,
            });
            obj.options = arrOptions;
            return;
          }
          else if (
            Array.isArray(option.selected) &&
            option.selected.length > 0
          ) {
            option.selected
              .forEach((element) => {
                arrOptions.push({
                  id: option.id,
                  value: element,
                });
              });

            if (arrOptions.length > 0) obj.options = arrOptions;

            return;
          }
        });
      }
      if (withComment && item.comment) obj.comment = item.comment;
      objCart.push(obj);
    });
    return objCart;
  },
  generateCouponObject: (cart) => {
    return new Promise(function (resolve) {
      let coupon = {
        cart: cartManager.generateCartObject(cart, true),
        coupon: cart.coupon,
        order_type: cart.orderType,
        location_id: cart.locationId,
      };
      resolve(coupon);
    });
  },
  generateOrderObject: (cart, id) => {
    return new Promise(function (resolve) {
      let order = {
        location_id: id,
        cart: cartManager.generateCartObject(cart, true),
        order_type: cart.orderType,
        order_for_date:
          cart.pickUp.type == enumHelper.PickupTime.LATER
            ? helpers.generateFormatedDateTime(
              cart.pickUp.date,
              "date",
              "YYYY-MM-DD"
            ) +
            " " +
            helpers.generateFormatedDateTime(
              cart.pickUp.time,
              "time",
              "HH:mm:ss"
            )
            : null,
      };

      //--- used for guest users
      if (cart.user) {
        order.first_name = cart.user.first_name;
        order.last_name = cart.user.last_name;
        order.telephone_number = cart.user.telephone_number;
        order.email = cart.user.email;
      }
      if (cart.orderType == enumHelper.orderType.Delivery) {
        order.delivery_fee = cart.delivery_fee;
        if (cart.driver_instructions)
          order.driver_instructions = cart.driver_instructions;

        if (cart.address.id) {
          order.address_id = cart.address.id;
        } else {
          order.address = {
            address_line_1: cart.address.address_line_1,
            address_line_2: cart.address.address_line_2,
            city: cart.address.city,
            region: cart.address.region,
            postcode: cart.address.postcode,
            country: cart.address.country,
            street_number: cart.address.street_number
          };
        }
      }

      order.service_charge = cart.service_charge;

      order.bag_charge = cart.bag_charge;

      if (cart.comment) order.comment = cart.comment;

      if (cart.coupon && cart.coupon_result) order.coupon = cart.coupon;

      if (cart.orderType == 3 && cart.table) order.table_id = cart.table.id;

      resolve(order);
    });
  },

  generatePaymentObject: (cart, idLocation, isNativePay = false) => {
    return new Promise(function (resolve) {
      let objPayment = {
        location_id: idLocation,
        order_id: cart.newOrder.id,
        payment_type: cart.payment_type,
      };
      if (cart.payment_type >= enumHelper.paymentType.Card) {

        if (isNativePay && [enumHelper.paymentType.ApplePay, enumHelper.paymentType.GooglePay].includes(cart.payment_type)) {
          objPayment = {
            ...objPayment,
            ...{
              stripe_payment_method_id: cart.paymentMethodId
            }
          }
        } else {
          if (cart.card_id) objPayment.card_id = cart.card_id;
          else {
            objPayment = {
              ...objPayment,
              ...{
                card: cart.card,
                save_card: cart.save_card,
                first_name: cart.user.first_name,
                last_name: cart.user.last_name,
                telephone_number: cart.user.telephone_number,
                email: cart.user.email,
                service_charge: cart.service_charge,
                bag_charge: cart.bag_charge
              }
            }

          }
        }
      }
      resolve(objPayment);
    });
  },
  setOrderTotal: function (cart) {
    return new Promise((resolve) => {
      //---- reduce the coupon discount
      if (cart.coupon_result) {
        cart.orderTotal = cart.coupon_result.afterDiscountCartTotal;
        cart.total = cart.coupon_result.cartTotal;
      } else {
        let total = helpers.getOrderTotal(cart, cart.orderType);
        cart.orderTotal = total;
        cart.total = total;
      }
      if (cart.order.length) {
        cart.orderTotal += parseFloat(cart.service_charge);
        cart.orderTotal += parseFloat(cart.bag_charge);
        if (cart.orderType == enumHelper.orderType.Delivery)
          cart.orderTotal += cart.delivery_fee;
      }

      resolve(cart);
    });
  },
  updateCoupon: function (cart) {
    return new Promise((resolve) => {
      cartManager.generateCouponObject(cart).then((coupon) => {
        cartManager
          .postVerifyCoupon(coupon)
          .then((result) => {
            if (result.coupon) {
              resolve(result);
            } else {
              resolve(null);
            }
          })
          .catch(() => {
            resolve(null);
          });
      });
    });
  },
  postVerifyCoupon: (data) => {
    return new Promise((resolve, reject) => {
      api.coupon
        .veriy(data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e.response);
        });
    });
  },
};
